import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=82791e6c&"
import script from "./OrderManagement.vue?vue&type=script&lang=js&"
export * from "./OrderManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports